var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaiAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h14q.824 0 1.413.588Q18 1.175 18 2v14q0 .824-.587 1.413A1.93 1.93 0 0 1 16 18zm0-2h14V2H2zm3-2h5q.424 0 .713-.287A.97.97 0 0 0 11 13a.97.97 0 0 0-.287-.713A.97.97 0 0 0 10 12H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 13q0 .424.287.713Q4.576 14 5 14m0-4h8q.424 0 .713-.287A.97.97 0 0 0 14 9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 8H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 9q0 .424.287.713Q4.576 10 5 10m0-4h8q.424 0 .713-.287A.97.97 0 0 0 14 5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 4H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 5q0 .424.287.713Q4.576 6 5 6",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaiAgent);
export default __webpack_public_path__ + "static/media/CAI_agent.60533a4abcb3fca567c8d438aa8436b1.svg";
export { ForwardRef as ReactComponent };